import React from "react";
import { useMutation } from "@apollo/client";
import { SINGLE_UPLOAD } from "../schemas/announcements";

export type UploadFileI = {
    callback: (a:SingleUploadI) => void;
}

export type SingleUploadI = {
    url: string;
    filename: string;
}

const UploadFile = ({ callback }: UploadFileI) => {
    const [mutate, { loading, error }] = useMutation(SINGLE_UPLOAD);
    const onChange = async ({
        target: {
            validity,
            files: [file]
        }
    }: any) => {
        if (validity.valid) {
            const res = await mutate({ variables: { file } })
            callback(res?.data?.singleUpload)
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{JSON.stringify(error, null, 2)}</div>;

    return (
        <React.Fragment>
            <input type="file" required onChange={onChange} />
        </React.Fragment>
    );
};

export default UploadFile;